/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCopyFieldFrom = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M1.998 1h20v6h-20zm2 2v2h16V3zm2.586 8L5.291 9.707l1.414-1.414L10.412 12l-3.707 3.707-1.414-1.414L6.584 13H1.998v-2zm13.414 0h-8V9h10v6h-10v-2h8zm-18 6h20v6h-20zm2 2v2h16v-2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCopyFieldFrom as CopyFieldFrom };
